import { render, staticRenderFns } from "./VerificationCallback.vue?vue&type=template&id=6466be86&scoped=true&"
import script from "./VerificationCallback.vue?vue&type=script&lang=js&"
export * from "./VerificationCallback.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCallback.vue?vue&type=style&index=0&id=6466be86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466be86",
  null
  
)

export default component.exports